{
  "pt": {
    "milestone": {
      "actions": {
        "activate": "Ativar",
        "activate_phase": "Ativar esta fase",
        "complete_phase": "Concluir esta fase",
        "create": "Criar fase",
        "delete": "Eliminar",
        "delete_milestones": "Eliminar fase | Eliminar {count} fases",
        "move_down": "Mover a fase para baixo",
        "move_unit_back": "Repor a unidade aqui",
        "move_up": "Mover a fase para cima",
        "new": "Fase",
        "reactivate_phase": "Reativar esta fase"
      },
      "activate": {
        "body": "Todos os elementos desta fase são publicados para esta unidade e os responsáveis recebem uma notificação.",
        "body_empty": "Não torna nada visível para o cliente.",
        "body_intermediate": "As fases intermédias também são concluídas e todos os elementos anexados a elas são igualmente publicados.",
        "body_project": "Todos os elementos desta fase são publicados para este projeto e os responsáveis recebem uma notificação.",
        "body_reactivate": "Esta fase volta a ser a fase atual. Nada é retirado: tudo o que já foi publicado ou enviado permanece. As fases seguintes voltam a ficar planeadas.",
        "confirm": "Ativar",
        "confirm_publish": "Ativar e enviar",
        "confirm_reactivate": "Reativar",
        "past_warning": "Voltar a uma fase anterior não desfaz as ações já realizadas. Tudo o que foi partilhado com os clientes não será automaticamente revogado.",
        "title": "Ativar fase",
        "title_activate": "Ativar “{name}”?",
        "title_reactivate": "Reativar “{name}”?",
        "verb_default": "Acionar",
        "verb_share": "Partilhar"
      },
      "assign": {
        "body": "As unidades selecionadas passam para “{to}”. Os elementos de “{to}” e de cada fase saltada tornam-se visíveis para o cliente e os responsáveis recebem uma notificação.",
        "body_phases_only": "As unidades selecionadas passam para “{to}”. O cliente vê a nova fase.",
        "excluded": "Não é possível selecionar unidades que já estão em “{to}” ou mais à frente."
      },
      "attach": {
        "add": "Adicionar",
        "add_and_move": "Adicionar e mover",
        "assigned_tag": "Atribuído",
        "back": "Voltar",
        "counts": "{available} disponíveis · {assigned} já atribuídos",
        "description_decision": "Escolhas que o cliente tem de fazer",
        "description_survey": "Questionários para recolher respostas",
        "description_todo": "Tarefas que o cliente tem de concluir",
        "elsewhere_tag": "Agora em {name}",
        "empty": "Nenhum elemento disponível",
        "empty_state_description": "Consoante o seu plano, pode adicionar {kinds} a esta fase.",
        "intro": "Escolha que tipo de elemento pretende associar a esta fase.",
        "move_notice_body": "O que já foi enviado continua enviado. A fase anterior perde este elemento.",
        "move_notice_item": "{element}, agora em {phase}",
        "move_notice_title": "Este elemento passa para «{name}» | Estes elementos passam para «{name}»",
        "next": "Seguinte",
        "search": "Pesquisar",
        "select_intro": "Selecione o {kind} que pretende adicionar.",
        "subtitle": "À fase: {name}",
        "success": "Elementos adicionados",
        "title": "Adicionar elementos"
      },
      "complete_phase": {
        "body": "Esta unidade conclui esta fase e fica sem fase ativa. | {count} unidades concluem esta fase e ficam sem fase ativa.",
        "body_sup": "Este projeto conclui esta fase e fica sem fase ativa.",
        "confirm": "Concluir fase",
        "keep": "Manter a fase ativa",
        "title": "Concluir “{name}”?"
      },
      "delete_phase": {
        "body": "As unidades que estão nesta fase ficam sem fase ativa. Não passam para o passo anterior nem para o seguinte. Os elementos desta fase são desassociados, não eliminados. Os elementos já publicados numa unidade continuam publicados: esses eliminas na própria unidade.",
        "body_last": "As unidades que estão nesta fase ficam sem fase ativa. Como esta é a última fase, passam a contar como concluídas. Os elementos desta fase são desassociados, não eliminados. Os elementos já publicados numa unidade continuam publicados: esses eliminas na própria unidade.",
        "body_sup": "Este projeto fica sem fase ativa. Não passa para o passo anterior nem para o seguinte. Os elementos desta fase são desassociados, não eliminados. Os elementos já publicados continuam publicados: esses eliminas no próprio projeto.",
        "confirm": "Eliminar fase",
        "keep": "Manter fase",
        "title": "Eliminar “{name}”?"
      },
      "detach": {
        "body": "Isto retira o elemento desta fase. O elemento em si continua a existir e as unidades que já o viram mantêm-no. As novas unidades deixam de o receber nesta fase.",
        "confirm": "Desassociar",
        "keep": "Manter",
        "title": "Desassociar “{name}”?"
      },
      "filters": {
        "clear": "Limpar todos os filtros",
        "done": "Concluído",
        "group_milestones": "Fases",
        "group_status": "Estado",
        "group_title": "Conteúdo da fase",
        "no_phase": "Sem fase",
        "no_units_here": "Nenhuma unidade aqui",
        "nothing_assigned": "Nada atribuído",
        "phase_last": "Na última fase",
        "since_month_over": "Mais de um mês",
        "since_quarter_over": "Mais de 3 meses",
        "since_two_weeks_over": "Mais de 2 semanas",
        "title": "Filtros",
        "units_here": "Tem unidades aqui"
      },
      "labels": {
        "add_element": "Adicionar elemento",
        "assign_units": "Atribuir unidades",
        "assigned_count": "0 atribuído | 1 atribuído | {count} atribuídos",
        "assigned_elements": "Elementos atribuídos",
        "assigned_empty_description": "Anexe {kinds} a esta fase",
        "assigned_empty_title": "Ainda não há elementos",
        "bulk_assign_title": "Selecionar as unidades a que pretende atribuir a fase '{milestone_name}'",
        "complete_units": "Concluir {count} unidade | Concluir {count} unidades",
        "completed_subtitle": "Estas unidades percorreram o fluxo de trabalho",
        "completed_title": "Concluído",
        "detach": "Desassociar",
        "detach_element": "Desassociar {name}",
        "drag_to_reorder": "Arraste para reordenar",
        "edit_milestone": "Editar fase",
        "element_count": "{count} elemento | {count} elementos",
        "elements_assign_link": "Atribuir elementos em Workflows",
        "elements_empty": "Ainda não há elementos atribuídos a esta fase.",
        "elements_visible": "Visível para o cliente: {elements}",
        "kind_decision": "Decisão | Decisões",
        "kind_decision_count": "{count} decisão | {count} decisões",
        "kind_survey": "Inquérito | Inquéritos",
        "kind_survey_count": "{count} inquérito | {count} inquéritos",
        "kind_todo": "Tarefa | Tarefas",
        "kind_todo_count": "{count} tarefa | {count} tarefas",
        "locked_not_sent": "{count} elemento está bloqueado pelo seu plano e não será enviado. | {count} elementos estão bloqueados pelo seu plano e não serão enviados.",
        "locked_tooltip": "Não incluído no seu plano atual. Não será enviado aos clientes.",
        "milestone": "Fase",
        "milestone_current": "Fase atual",
        "milestone_name": "Nome da fase",
        "move_units_to": "Mover {count} unidade para {name} | Mover {count} unidades para {name}",
        "new_milestone": "Nova fase",
        "no_results": "Não foram encontradas fases",
        "please_select": "Selecionar uma nova fase",
        "position": "Posição",
        "progress": "Progresso",
        "publishes_empty": "Nada atribuído ainda",
        "publishes_summary": "Torna {elements} visíveis para o cliente",
        "reorder_filtered": "Limpa a pesquisa ou o filtro para reordenar as fases",
        "search_empty_state": "Ainda não foram criadas fases. Clique aqui para começar",
        "search_phase": "Procurar fase",
        "search_unit": "Procurar unidade",
        "search_units": "Pesquisar unidades",
        "since": "Desde",
        "started_on": "Iniciada em {date}",
        "status_active": "Em curso",
        "status_completed": "Concluída",
        "status_planned": "Planeada",
        "unit_active_since": "Em curso desde {date}",
        "unit_completed_on": "Concluído em {date}",
        "unit_timeline_empty": "Ainda não foram criadas fases para este projeto.",
        "units": "Unidades",
        "units_completed": "Nenhuma unidade concluída | 1 unidade concluída | {count} unidades concluídas",
        "units_empty": "Ainda nenhuma unidade chegou a esta fase.",
        "units_here": "Nenhuma unidade aqui | 1 unidade aqui | {count} unidades aqui",
        "units_no_results": "Nenhuma unidade encontrada",
        "unstarted_subtitle": "Estas unidades não têm uma fase ativa",
        "unstarted_title": "Sem fase",
        "view_phases": "Fases",
        "view_units": "Unidades",
        "warning_delete": "Se eliminar uma fase que tenha sido atribuída a uma unidade, o cliente perderá a noção da fase em que se encontra a sua unidade. Certifique-se de que atribui uma nova fase a estas unidades!"
      },
      "move": {
        "body": "Esta unidade passa de “{from}” para “{to}”. Os elementos de “{to}” tornam-se visíveis para o cliente e os responsáveis recebem uma notificação. | Estas unidades passam de “{from}” para “{to}”. Os elementos de “{to}” tornam-se visíveis para o cliente e os responsáveis recebem uma notificação.",
        "body_phases_only": "Esta unidade passa de “{from}” para “{to}”. O cliente vê a nova fase. | Estas unidades passam de “{from}” para “{to}”. O cliente vê a nova fase.",
        "confirm": "Mover e notificar",
        "confirm_phases_only": "Mover",
        "elements": "Torna {elements} visível para o cliente",
        "title": "Mover {count} unidade para “{name}”? | Mover {count} unidades para “{name}”?"
      },
      "overview": {
        "no_phase": "Sem fase",
        "not_started": "Não iniciado",
        "since_date": "Desde {date}",
        "step_of": "Passo {step} de {total}"
      },
      "publication_failed": {
        "body": "O envio dos elementos desta fase falhou para 1 unidade. | O envio dos elementos desta fase falhou para {count} unidades.",
        "retried": "Os elementos estão a ser enviados novamente",
        "retry": "Enviar novamente"
      },
      "reorder": {
        "body_earlier": "Antecipar esta fase não retira nada do que já foi publicado. As unidades mantêm o que têm; só muda a ordem.",
        "body_earlier_sup": "Antecipar esta fase não retira nada do que já foi publicado. O projeto mantém o que tem; só muda a ordem.",
        "body_later": "Adiar esta fase não retira nada do que já foi publicado. As unidades mantêm o que têm; só muda a ordem.",
        "body_later_sup": "Adiar esta fase não retira nada do que já foi publicado. O projeto mantém o que tem; só muda a ordem.",
        "body_passed": "As unidades numa fase posterior passam agora por esta fase. Tudo o que lhe está associado é-lhes publicado de imediato.",
        "body_passed_sup": "Este projeto passa agora por esta fase. Tudo o que lhe está associado é publicado de imediato.",
        "body_passes": "As unidades nesta fase passam agora pelas fases intermédias. Tudo o que está associado a essas fases é-lhes publicado de imediato.",
        "body_passes_sup": "Este projeto passa agora pelas fases intermédias. Tudo o que está associado a essas fases é publicado de imediato.",
        "confirm": "Mover fase",
        "count": "{count} unidade passa por {phases} de uma vez | {count} unidades passam por {phases} de uma vez",
        "count_sup": "Este projeto passa por {phases} de uma vez",
        "crossed": "{name} ({elements})",
        "nothing": "nada",
        "phases": "{count} fase | {count} fases",
        "title": "Colocar “{name}” depois de “{previous}”?",
        "title_first": "Colocar “{name}” em primeiro lugar?"
      },
      "toasts": {
        "bulk_assigned": "A fase é atribuída com êxito às unidades selecionadas",
        "create_success": "Fase criada com sucesso",
        "deleted": "Fase eliminada",
        "phase_without_units": "Já não há unidades nesta fase",
        "sup_assigned": "A fase foi ativada com êxito",
        "sup_completed": "Fase concluída",
        "units_completed": "{count} unidade concluída | {count} unidades concluídas",
        "units_moved": "{count} unidade movida | {count} unidades movidas",
        "update_success": "As fases foram atualizadas com sucesso"
      },
      "validation": {
        "needNamePrimary": "O nome na língua principal ({language}) é obrigatório"
      }
    }
  }
}
